import React, { useEffect, useState } from "react";
import {
	Breadcrumb,
	Form,
	Row,
	Col,
	Card,
	Button,
	Space,
	BackTop,
	Radio,
	message,
	Spin,
	Input,
	InputNumber,
} from "antd";
import "../../../styles/admin.css";
import { useHistory } from "react-router";
import constants from "../../../constants/constants";
import { fetchAdminApi } from "../../../services/api";
import Loader from "../../Common/Cred/Loader";
import { removeExtraSpaces } from "../../../globalFunctions/GlobalFunctions";
const AddEditPromoCode = () => {
	const history = useHistory();
	const [form] = Form.useForm();
	const [isPaid, setIsPaid] = useState("0");
	const [iseBook, setIseBook] = useState("0");
	const [loader, setLoader] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [promoId, setPromoId] = useState(null);
	useEffect(() => {
		const editFlag = sessionStorage.getItem("isEdit");
		const editData = JSON.parse(sessionStorage.getItem("editCodeData"));
		if (editFlag === "true" && editData) {
			setIsEdit(true);
			setPromoId(editData.promo_id);
			form.setFieldsValue({
				duration: editData.Duration,
				promocode: editData.Promo_Code,
			});
			setIsPaid(String(editData.is_paid));
			setIseBook(String(editData.ebook));
		}
	}, [form]);
	const onCancelBtn=()=>{
		form.resetFields();
		history.push({ pathname: "/promo-code-list" });
		sessionStorage.removeItem("editCodeData");
		sessionStorage.removeItem("isEdit");
	};
	//On CheckBox Change
	const OnCheckBoxChange = (e) => {
		setIsPaid(e.target.value);
	};
	//On CheckBox Change
	const OnBookChange = (e) => {
		setIseBook(e.target.value);
	};
	const onFormFinish = (values) => {
		const payload = {
			duration: values.duration,
			type: "1",
			promo_code: removeExtraSpaces(values.promocode),
			is_paid: isPaid,
			ebook: iseBook,
			...(isEdit && { promo_id: promoId }),
		};
		setLoader(true);
		fetchAdminApi(`/update-promocode`, "post", payload).then((res) => {
			if (res && res.code) {
				setLoader(false);
				if (res.code === 200) {
					message.success(res.message);
					history.push({ pathname: "/promo-code-list" });
					sessionStorage.removeItem("editCodeData");
					sessionStorage.removeItem("isEdit");
				} else {
					message.error(res.message);
				}
			} else {
				message.error("Failed to download");
				setLoader(false);
			}
		});
	};
	const handleValidateBookCode = (rule, value, callback) => {
		try {
			if (!value) {
				throw new Error("Enter Promocode");
			}
			const hyphenCount = (value.match(/-/g) || []).length;
			const isValidCharacters = /^[A-Za-z0-9-]+$/.test(value);
			if (hyphenCount !== 4 || !isValidCharacters) {
				throw new Error(constants.PromoCodeValidationMessage);
			}
			callback();
		} catch (err) {
			callback(err);
		}
	};
	return (
		<>
			<Spin spinning={loader} size="large" indicator={<Loader/>}>
				<div className="gray-bg h-86vh">
					<div className="p-3">
						<Breadcrumb>
							<Breadcrumb.Item>
								<a
									onClick={() => {
										history.push({ pathname: "/admin-dashboard" });
									}}
								>
									{constants.Home}
								</a>
							</Breadcrumb.Item>
							<Breadcrumb.Item>
								<a
									onClick={() => {
										history.push({ pathname: "/masters-menu" });
									}}
								>
									{constants.Masters}
								</a>
							</Breadcrumb.Item>
							<Breadcrumb.Item>
								<a
									onClick={() => {
										history.push({ pathname: "/promo-code-list" });
									}}
								>
									{constants.PromocodeList}
								</a>
							</Breadcrumb.Item>
							<Breadcrumb.Item>{isEdit ? constants.EditPromocode : constants.AddPromocode}</Breadcrumb.Item>
						</Breadcrumb>
					</div>
					<div className="p-4 ">
						<BackTop/>
						<Row gutter={[24, 24]} className="mt-4">
							<Col
								xs={24}
								sm={{
									span: 22,
									offset: 1,
								}}
								lg={{
									span: 14,
									offset: 6,
								}}
							>
								<Card
									size="small"
									title={
										<span className="text-uppercase">
											{isEdit ? constants.EditPromocode : constants.AddPromocode}
										</span>
									}
								>
									<Form layout="vertical" form={form} onFinish={onFormFinish}>
										<Row gutter={[24, 0]} className="">
											<Col xs={24} sm={12} md={12} lg={12}>
												<Form.Item
													className="label-default"
													label="Duration (in months)"
													name="duration"
													rules={[
														{
															required: true,
															message: "Enter months",
														},
													]}
												>
													<InputNumber
														min={1}
														className="w-100"
														placeholder="Months"
													/>
												</Form.Item>
											</Col>
											<Col xs={24} sm={12} md={12} lg={12}>
												<Form.Item
													className="label-default"
													label="Promocode"
													name="promocode"
													rules={[
														{
															required: true,
															message: "",
														},
														{ validator: handleValidateBookCode },
													]}
												>
													<Input className="w-100" placeholder="xxxxx-xxxxx-xxxxx-xxxxx-xxxxx"/>
												</Form.Item>
											</Col>
											<Col xs={24} sm={12} md={12} lg={12}>
												<Form.Item name="registerRenew">
													<span>{constants.PaymentMode}</span>
													<Radio.Group
														value={isPaid}
														buttonStyle="solid"
														onChange={(e) => OnCheckBoxChange(e)}
													>
														<Radio.Button value="0">{constants.Free}</Radio.Button>
														<Radio.Button value="1">{constants.Paid}</Radio.Button>
													</Radio.Group>
												</Form.Item>
											</Col>
											<Col xs={24} sm={12} md={12} lg={12}>
												<Form.Item name="eBook">
													<span>{constants.TypeOfBook}</span>
													<Radio.Group
														value={iseBook}
														defaultValue="0"
														buttonStyle="solid"
														onChange={(e) => OnBookChange(e)}
													>
														<Radio.Button value="1">{constants.eBook}</Radio.Button>
														<Radio.Button value="0">{constants.Book}</Radio.Button>
													</Radio.Group>
												</Form.Item>
											</Col>
											<Col xs={24} sm={24} md={24} lg={24}>
												<Form.Item>
													<Space
														align="end"
														direction="horizontal"
														className="button-wrapper"
													>
														<Button className="btnDb" htmlType="submit">
															{constants.Save}
														</Button>
														<Button onClick={onCancelBtn}>
															{constants.CancelBTN}
														</Button>
													</Space>
												</Form.Item>
											</Col>
										</Row>
									</Form>
								</Card>
							</Col>
						</Row>
					</div>
				</div>
			</Spin>
		</>
	);
};
export default AddEditPromoCode;
